<template>
  <div class="login" :style="{ backgroundImage: `url(${bgImage})` }">
    <Header :isShow="false"></Header>
    <div class="bg">
      <div class="login-box">
        <div class="top-title leftW" :style="{ color: topTitleColor }">
          Welcome to IC Bench
        </div>
        <div class="title-desc leftW">Phone Number</div>
        <div class="input-box leftW">
          <div class="input-left">
            <el-dropdown trigger="click" @command="countryCommand">
              <el-button class="phone-btn">
                +{{ curCountryCode
                }}<i class="el-icon-caret-bottom el-icon-caret-top"></i>
              </el-button>
              <template #dropdown>
                <el-dropdown-menu class="phone-dropdown">
                  <el-dropdown-item
                    v-for="(code, index) in countryCodeList"
                    class="dropdown-item"
                    :command="index"
                    :key="index"
                    >{{ code }}</el-dropdown-item
                  >
                </el-dropdown-menu>
              </template>
            </el-dropdown>
          </div>
          <div class="gun"></div>
          <el-input
            class="input-right"
            ref="inputCode"
            placeholder="Enter your phone number"
            v-model="phone"
            type="tel"
            @input="change"
            @keyup.enter="nextDo"
          />
        </div>
        <el-button
          v-loading="loading"
          class="next"
          :style="{
            backgroundColor: nextStyle.backgroundColor,
          }"
          @click="nextDo"
          :disabled="isable"
          >Next</el-button
        >
        <section class="agree-box">
          <el-checkbox v-model="isChecked"></el-checkbox>
          <p class="agree-title">I have read and accept the  <a href="/service-agreemnet.html" target="_blank">Terms of Service</a> and <a href="/privacy-policy.html" target="_blank">Privacy Policy</a></p>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import { ElMessage } from "element-plus";
import {
  createCaptcha,
  errorMessageMap
} from "@/request/api";
import { setCodeDown, clearAllStorage } from "@/utils/Setitem";
import { allCountries, isDayTime } from "@/utils/common";

import nightImage from "@/assets/night-bg-img.jpg";
import dayTimeImage from "@/assets/daytime-bg-img.jpg";
let interval;

export default {
  name: "login",
  data() {
    return {
      phone: "",
      isable: true,
      countryCodeList: [],
      curCountryCode: "86",
      nextStyle: {
        backgroundColor: "#C7C7C7",
      },
      bgImage: null,
      topTitleColor: "#000000",
      loading: false,
      isChecked: false,
    };
  },
  methods: {
    countryCommand(index) {
      const dialCode = this.countryCodeList[index];
      this.curCountryCode = dialCode;
    },
    async nextDo() {
      console.log(this.phone);
      if (!this.phone) {
        ElMessage("please enter your mobile phone number");
        return;
      }
      if (!this.isChecked) {
        ElMessage("Please check Protocol and Privacy below");
        return;
      }
      this.loading = true;
      try {
        clearAllStorage()
        await createCaptcha(this.phone, this.curCountryCode);
        this.$message.success("sent successfully");
        const endMs = new Date().getTime() + 60000;
        setCodeDown(endMs);
        this.$router.push({
          name: "Code",
          params: { phone: this.phone, countryCode: this.curCountryCode },
        });
        this.loading = false;
      } catch (e) {
        this.loading = false;
        console.log(e);
        const message = e.message;
        let msg = "get validation failed"
        if (message.includes("errorId:")) {
          const errorId = message.split("errorId:").pop();
          if (errorId) {
            msg = errorMessageMap.get(errorId) || msg;
          }
        } else {
          msg = errorMessageMap.get(message) || msg;
        }
        this.$message.warning(msg);
      }
    },
    change() {
      if (this.phone) {
        this.nextStyle.backgroundColor = "#0050B3";
        this.isable = false;
      } else {
        this.nextStyle.backgroundColor = "#C7C7C7";
        this.isable = true;
      }
    },
  },
  mounted() {
    this.$refs?.inputCode?.focus()
  },
  beforeUnmount() {
    clearInterval(interval);
  },
  
  created() {
    const list = allCountries.map(([name, iso2, dialCode]) => ({
      name,
      iso2: iso2,
      dialCode,
    }));
    const countryList = [];
    for (const country of list) {
      countryList.push(country.dialCode);
    }
    countryList.sort((project1, project2) => project1 - project2);
    this.countryCodeList = [...new Set(countryList)];
  },
  beforeCreate() {
    interval = setInterval(() => {
      const isDay = isDayTime();
      if (isDay) {
        this.bgImage = dayTimeImage;
        this.topTitleColor = "#000000";
      } else {
        this.bgImage = nightImage;
        this.topTitleColor = "#ffffff";
      }
    }, 100);
  },
  components: {
    Header,
  },
};
</script>
<style lang='less' scoped>
.login {
  width: 100%;
  height: 100%;
  position: absolute;
  background-size: 100% 100%;
}
.bg {
  // height: calc(100% - 102px);
  margin: 0 auto;
  display: flex;
  align-items: center;
  margin-left: 300px;
  margin-top: 5%; //90px;
  min-width: 400px;
}
.login-box {
  width: 550px;
  background-color: #fff;
  border-radius: 6px;
  background-color: #fff;
  background-color: rgba(255, 255, 255, 0.4);
  padding: 50px 0px 80px 0px;
}
.leftW {
  margin-left: 38px;
}
.top-title {
  color: #000000;
  font-weight: 900;
  font-size: 32px;
  text-align: left;
}
.title-desc {
  color: #0050b3;
  font-size: 18px;
  text-align: left;
  margin-top: 20px;
  font-weight: 500;
  width: 130px;
  line-height: 50px;
  // background-color: red;
  border-style: none none solid none;
  border-width: 3px;
  border-color: #0050b3;
}
.input-box {
  display: flex;
  // flex-direction: column;
  align-items: center;
  // background-color: red;
  margin-right: 38px;
  margin-top: 30px;
  border: 1px solid #0050b3;
  border-radius: 8px;
  height: 50px;
  background-color: #fff;

  .input-left {
    width: 80px;
    color: #acacac;
    text-align: center;
    font-size: 20px;
  }
  .gun {
    background-color: #acacac;
    height: 35px;
    width: 1px;
  }
  .input-right {
    margin-left: 2px;
    color: #565656;
    font-size: 17px;
    font-weight: 500;
    height: 45px;
  }
}
.next {
  background-color: #c7c7c7;
  color: #fff;
  font-size: 20px;
  height: 50px;
  // margin-top: 20px;
  width: calc(100% - 76px);
  // margin-right: 38px;
  border-radius: 8px;
  border: 0px solid #707070;
  margin-top: 30px;
  background-color: orange;
}
.agree-box {
  display: flex;
  margin: 0 auto;
  color: #fff;
  font-size: 20px;
  // height: 50px;
  align-items: center;
  
  // margin-top: 20px;
  width: calc(100% - 76px);
  // margin-right: 38px;
  border-radius: 8px;
  border: 0px solid #707070;
  margin-top: 10px;
  // background-color: orange;
  .agree-img {
    width: 15px;
    height: 15px;
    background-color: red;
    display: flex;
    align-items: center;
    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
  .agree-title {
    font-size: 14px;
    font-weight: 500;
    color: #565656;
    margin-left: 10px;
    a {
      text-decoration: none;
      color: #0050b3;
    }
  }
}

.dialog-top {
  display: flex;
  align-items: center;
  margin-left: 20px;
  // background-color: red;
  margin-top: -30px;
  width: 200px;
  height: 25px;
  img {
    object-fit: contain;
    width: 20px;
    height: 20px;
  }
  .dialog-top-title {
    margin-left: 10px;
    font-weight: 900;
    font-size: 22px;
    color: #000;
  }
}
.dialog-middle {
  margin-left: 60px;
  margin-top: 20px;
  padding-right: 60px;

  .dialog-title {
    font-size: 18px;
    color: #565656;
    font-weight: 400;
  }

  .dialog-middle-one {
    text-align: left;
    overflow: hidden;
    hyphens: auto;
  }
  .dialog-middle-two {
    text-align: left;
    overflow: hidden;
    hyphens: auto;
  }
  .dialog-middle-three {
    margin-top: 15px;
    text-align: left;
    overflow: hidden;
    hyphens: auto;
  }
  .dialog-middle-four {
    color: #0050b3;
    text-align: left;
    overflow: hidden;
    hyphens: auto;
  }
}
.dialog-bottom {
  margin-top: 30px;
  display: flex;
  justify-content: flex-end;

  .dialog-bottom-btn {
    justify-content: center;
    align-items: center;
    width: 120px;
    height: 35px;
    font-weight: 500;
    font-size: 16px;
    border-width: 1px;
    border-color: #707070;
  }
}
:deep(.el-dialog) {
  border-radius: 8px;
  width: 550px !important;
  height: 323px;
}

:deep(.el-input__wrapper) {
  border: 0 !important;
  box-shadow:none !important;
}

.phone-btn {
  border-width: 0px;
  height: 45px;
  width: 80px;
}
.phone-dropdown {
  height: 300px;
  overflow: auto;
}
.el-dropdown-menu__item {
  color: #565656 !important;
  width: 80px !important;
}
</style>